import i18n from "@/i18n";
import type { TOptions } from "i18next";
import {
  normalizeSupportedLanguage,
  type SupportedLanguageCode,
} from "@/lib/language-detection";

export const resolveToastLanguage = (
  preferred?: unknown,
): SupportedLanguageCode => {
  const fallbackLanguage = normalizeSupportedLanguage(i18n.language, "en");
  return normalizeSupportedLanguage(preferred, fallbackLanguage);
};

export const getToastT = (preferred?: unknown) =>
  i18n.getFixedT(resolveToastLanguage(preferred));

export const translateToast = (
  key: string,
  options?: string | TOptions,
  preferred?: unknown,
) => getToastT(preferred)(key, options as TOptions);
